import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M8 2C4.688 2 2 4.688 2 8s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6m0 10.8A4.8 4.8 0 0 1 3.2 8c0-1.11.378-2.13 1.014-2.94l6.726 6.726A4.74 4.74 0 0 1 8 12.8m3.786-1.86L5.06 4.214A4.74 4.74 0 0 1 8 3.2c2.652 0 4.8 2.148 4.8 4.8 0 1.11-.378 2.13-1.014 2.94" }, null, -1)
  ]))]))
}
export default { render: render }